<template>
  <div class="copyrightRiskDrop">
    <div class="title">
      <span class="red">{{getCartItemsNum()}}</span>
      <span>款素材及权益需要获得商业授权</span>
    </div>
    <div class="content">
      <ul>
        <template v-for="(item, i) in list">
          <li
            v-if="sprites[i] && sprites[i].html && !item.scale"
            :key="i"
            v-html="sprites[i] && sprites[i].html"
          ></li>
          <li
            v-if="sprites[i] && sprites[i].html && (sprites[i] || {}).scale > 0"
            :key="i"
            v-html="sprites[i] && sprites[i].html"
            :style="{
              'transform': ('scale('+sprites[i].scale+','+sprites[i].scale+')'),
            }"
          ></li>
        </template>
        <li
          v-for="(item, i) in getPlaceholders(list, listCols)"
          :key="i+'p'"
          class="placeholder"
          :style="item.style"
        ></li>
      </ul>
    </div>
    <div
      class="view-btn"
      @click="delVip"
    >查看版权及付费权益清单</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Analysis from "@/components/mixins/analysis/materialBu";

export default {
  mixins: [Analysis],
  name: "copyrightRiskDrop",
  data () {
    return {
      list: [],
      listCols: 4,
      listLimit: 8,
      sprites: [],
    };
  },
  computed: {
    ...mapGetters(["TOOL", "UserEquity", "IsVipSprites", "UserMsg"]),
  },
  watch: {
    "IsVipSprites.data" (val = []) {
      this.loadCartItems(val);
    },
  },
  created () {
    this.$bus.on("topnav.editorLoadMore", this.loadCartItems);
  },
  methods: {
    delVip () {
      this.materialPushAnalysisTwo("delVipBtn");
      this.$bus.emit("Modal_vue", {
        name: "delVip",
        data: {
          type: "record",
        },
      });
    },
    getPlaceholders (list, cols) {
      let listLen = list.length;
      let len = cols - (listLen % cols);
      let list2 = [];
      for (let i = 0; i < len; i++) {
        list2.push({
          style: `width: 50px; height: 0;opacity: 0;`,
        });
      }
      return list2;
    },
    async loadSprites (list) {
      let sprites = [];
      list.forEach(async (sprite) => {
        sprites.push(await this.loadSprite(sprite));
      });
      this.sprites = sprites;
    },
    async loadSprite (sprite) {
      let vipData = {};
      let spriteData, scenesData;
      switch (sprite.type) {
        case "bg":
          scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
          if (scenesData) {
            let t = scenesData.background.contentbg
              .find(".mask-blur")
              .prop("outerHTML");
            let $t = $(t).css({
              margin: 0,
              backgroundSize: "100% 100%",
            });
            vipData.html = $t[0].outerHTML;
          }
          break;

        case "scenes":
          scenesData = this.TOOL.getScenesIdData(sprite.id);
          let _data = await scenesData.getThumbnails();
          // $('<div>' + _data.dom + '</div>').children().eq(0)
          // let _dom = $('<div>' + _data.dom + '</div>');
          // _dom.css({position: 'relative'});
          // let _bg = _dom.children().eq(0);
          // _bg.css({ width: '100%', height: '100%' })
          // _bg.find('div').removeClass('mask-blur').css({ position: '', margin: 0, width: '100%', height: '100%', 'background-size': '100% 100%' })
          // vipData.html = _data.dom;// _dom.prop('outerHTML');
          // vipData.scale = 50 / _data.width;
          let b64 =
            "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTIgMTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEyIDEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzQ3NDI2MTt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTExLjEzLDEySDAuODZDMC4zOCwxMiwwLDExLjYyLDAsMTEuMTRWNi4wMWgxMS45OXY1LjE0QzExLjk5LDExLjYyLDExLjYxLDEyLDExLjEzLDEyTDExLjEzLDEyeiBNOS40MiwzLjQ0CgkJaDEuNzFjMC40NywwLDAuODYsMC4zOCwwLjg2LDAuODZ2MC44Nkg4LjEzTDkuNDIsMy40NHogTTMuODQsNS4xNWwxLjI5LTEuNzFoMi44TDYuNjQsNS4xNUgzLjg0TDMuODQsNS4xNXogTTAsNS4xNVY0LjI5CgkJYzAtMC40NywwLjM4LTAuODYsMC44Ni0wLjg2aDIuOGwtMS4zLDEuNzJIMEwwLDUuMTV6IE0wLjMzLDIuNTlsMTEuMDktMi41N2MwLjI0LTAuMDcsMC40OCwwLjA3LDAuNTUsMC4zCgkJYzAuMDYsMC4yMy0wLjA3LDAuNDYtMC4zLDAuNTNoLTAuMDFMMC41NywzLjQyYy0wLjI0LDAuMDctMC40OC0wLjA3LTAuNTUtMC4zYy0wLjA2LTAuMjMsMC4wNy0wLjQ2LDAuMy0wLjUzCgkJQzAuMzIsMi41OSwwLjMyLDIuNTksMC4zMywyLjU5TDAuMzMsMi41OXoiLz4KPC9nPgo8L3N2Zz4K";
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="${b64}" style="height: 26px;width: auto;"/></div>`;
          break;

        case "ScenesSound":
          scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="static/svg/copyright/copyright-music.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "AllSound":
        case 'TOOLsound':
        case "sound":
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="static/svg/copyright/copyright-music.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "uploadVideoNUM":
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="static/svg/copyright/copyright-membership.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "Text":
        case "RichText":
          vipData.html = `<div style="display: flex;align-items: center;justify-content: center;"><img src="static/svg/copyright/copyright-font.svg" style="height: 26px;width: auto;"/></div>`;
          break;

        case "groupSprites":
          scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
          let groupData = scenesData.getGroupData(sprite.id).data;
          vipData.html =
            '<img src="https://resources.laihua.com/' +
            groupData.thumbnailUrl +
            '" style="height: 100%;width: auto;"/>';

        default: {
          spriteData = this.TOOL.findSpriteById(sprite.id);
          if (spriteData) {
            scenesData = this.TOOL.getScenesIdData(spriteData.scenesId);
            let scenesList =
              scenesData.fromJsonLoadingState === 2 &&
              scenesData.getSprites({ height: 50, width: 50 });
            let $t = spriteData.thumbnails || $("<div></div>");
            this._id2unique($t.find('svg'));
            let eleWidth = $t.width();
            let eleHeight = $t.height();
            let boxWidth = 40;
            let boxHeight = 40;
            let scale;
            if (eleHeight > eleWidth) {
              scale = boxHeight / eleHeight;
            } else {
              scale = boxWidth / eleWidth;
            }
            $t.css({
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) scale(${scale}, ${scale})`,
            });
            // $t.css('transform', '');
            vipData.html = $t && $t.prop("outerHTML");
          }
        }
      }

      return vipData;
    },
    loadCartItems (val) {
      val = val || this.IsVipSprites.data;
      let limit = this.listLimit;
      this.list = val.length > limit ? val.slice(0, limit) : [...val];
      let list = this.list;
      if (this.UserMsg.payForMaterial == 1) {
        list = list.filter((v) => v.fileType === 15) || [];
      }
      this.loadSprites(list);
    },
    getCartItemsNum () {
      if (this.UserMsg.payForMaterial == 1) {
        let list = this.IsVipSprites.data || [];
        return (list.filter((v) => v.fileType === 15) || []).length;
      } else {
        return this.IsVipSprites.dataLength;
      }
    },
    _makeid: function () {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },

    // id去重
    _id2unique: function (svg) {
      var _this = this;
      svg.find('[id]').each(function () {
        var new_id = _this._makeid();
        // var old_id = this.attr('id');
        // svg.select('g,style,mask,defs').each(function() {
        //     var reg = new RegExp(old_id, 'g');
        //     this.node.innerHTML = this.node.innerHTML.replace(reg, new_id);
        // });
        $(this).attr('id', new_id);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.copyrightRiskDrop {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  margin: 0;
  background-color: #fff;
  border: 0 solid black;
  cursor: default !important;
}
.title {
  color: #474261;
  font-size: 14px;
  font-weight: normal;
}
.content {
  flex-grow: 1;
}
.view-btn {
  width: 228px;
  height: 32px;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  background: #5778fb;
  border-radius: 16px;
  cursor: pointer;
  &:hover {
    background-color: #5656e8;
  }
}
.red {
  color: #ea3d45;
}
.content {
  & ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
  }
  & > ul li {
    position: relative;
    width: 50px;
    height: 50px;
    margin-top: 10px;
    background: rgba(250, 250, 255, 1);
    border: 1px solid rgba(217, 221, 234, 1);
    border-radius: 4px;
  }
}
</style>

<style lang="scss">
.copyrightRiskDrop {
  & .content li {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* & .content li > div {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    bottom: 0 !important;
    right: 0 !important;
    z-index: 0 !important;
    margin: auto !important;
    // width: auto !important;
    // height: auto !important;
    width: 90% !important;
    height: 90% !important;
    // transform: scale(0.8) !important;
    & .frame-content > svg {
      width: 100%;
      height: 100%;
    }
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/copyrightRiskDrop.vue